import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";

export default function KioskSpotlight() {
  const { t } = useI18n();
  return (
    <section
      data-testid="kiosk-spotlight"
      className="relative bg-oj-ink text-white overflow-hidden"
    >
      <div className="absolute inset-0 noise opacity-40 pointer-events-none" />
      <div className="container-oj relative py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/80">
              <span className="h-1.5 w-1.5 rounded-full bg-oj-kiosk" /> {t("sections.kiosk_eyebrow")}
            </div>
            <h2 className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.92] text-balance">
              {t("sections.kiosk_title_a")}
              <span className="bg-oj-kiosk px-3 ml-2 rounded-md">{t("sections.kiosk_title_b")}</span>{" "}
              {t("sections.kiosk_title_c")}
            </h2>
            <p className="mt-6 max-w-xl text-lg text-zinc-300 leading-relaxed">
              {t("sections.kiosk_sub")}
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                t("kiosk_section.p1"),
                t("kiosk_section.p2"),
                t("kiosk_section.p3"),
                t("kiosk_section.p4"),
              ].map((tx) => (
                <li key={tx} className="flex items-start gap-2 text-sm text-zinc-200">
                  <Check className="size-4 text-oj-kiosk mt-0.5 shrink-0" />
                  {tx}
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <Link
                to="/solutions/kiosk"
                data-testid="kiosk-explore-cta"
                className="inline-flex items-center gap-1.5 bg-oj-kiosk text-white font-semibold px-6 py-4 rounded-md hover:opacity-90 transition-opacity"
              >
                {t("sections.kiosk_cta")} <ArrowUpRight className="size-5" />
              </Link>
              <Link
                to="/#demo"
                className="inline-flex items-center gap-1.5 border border-white/20 bg-white/5 text-white font-semibold px-6 py-4 rounded-md hover:bg-white/10 transition-colors"
              >
                {t("sections.kiosk_cta2")}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="absolute -inset-6 bg-oj-kiosk/20 blur-3xl rounded-full" />
            <div className="relative rounded-2xl border border-white/10 overflow-hidden">
              <img
                src="/images/kiosk.jpg"
                alt="O'javana Self-Order Kiosk in a modern café"
                className="w-full h-[520px] object-cover"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 right-4 flex items-center justify-between font-mono text-[11px]">
                <div className="bg-black/70 backdrop-blur px-2.5 py-1.5 rounded">kiosk-network · 4 active</div>
                <div className="bg-oj-kiosk px-2.5 py-1.5 rounded">+CHF 18.40 avg ticket</div>
              </div>
              <div className="absolute bottom-4 left-4 right-4 grid grid-cols-3 gap-3 font-mono text-[11px]">
                {[
                  ["queue −41%", "vs counter"],
                  ["AOV +22%", "smart upsell"],
                  ["uptime 99.9%", "30 days"],
                ].map(([k, v]) => (
                  <div key={k} className="bg-black/70 backdrop-blur rounded p-3">
                    <div className="font-display text-base font-bold text-white">{k}</div>
                    <div className="text-white/60 mt-1">{v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
